import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=3f189928"
import script from "./faq.ts?vue&type=script&lang=js&external"
export * from "./faq.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports